import { useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchEvents, deleteEvent, allEvents } from '../../features/events/eventsSlice';
import { fetchCampus } from "../../features/campus/campusSlice";
import { fetchPlaces } from "../../features/places/placesSlice";
import { fetchTypes } from "../../features/types/typesSlice";
import { fetchOds } from "../../features/ods/odsSlice";
import { fetchModalities } from "../../features/modalities/modalitiesSlice";
import { fetchThematics } from '../../features/thematics/thematicsSlice';
import { fetchAllAreas } from '../../features/areas/areasSlice'
import Content from './Content';
import Forms from './Forms';
import { CustomContainer } from "../Tools";

const checkIsRoot = user => user === 'root';

const Events = () => {
    const { type } = useSelector(state => state.auth);
    const { status } = useSelector(state => state.events);
    const isRoot = useMemo(() => checkIsRoot(type), [type])
    const dispatch = useDispatch()
    useEffect(() => {
        if(status === 'idle'){ 
            dispatch(fetchCampus())
            dispatch(fetchPlaces());
            dispatch(fetchTypes());
            dispatch(fetchOds())
            dispatch(fetchModalities())
            dispatch(fetchThematics());
            if(isRoot) {
                dispatch(fetchAllAreas())
                dispatch(allEvents())
            }else {
                dispatch(fetchEvents());
            }            
        }
    }, [status, dispatch, type, isRoot])
    const title = `Eventos`
    return(
        <CustomContainer
            content={<Content isRoot={isRoot}/>}
            forms={<Forms isRoot={isRoot}/>}
            fnConfirm={deleteEvent}
            title={title}
            size="xl"
        />
    )
}

export default Events;